var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2921_195949)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2921_195949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37618 4.26273H6.62462C6.55587 4.26273 6.49962 4.31898 6.49962 4.38773V8.68929C6.49962 8.72992 6.51837 8.76742 6.55118 8.79085L9.13399 10.6768C9.19024 10.7174 9.26837 10.7065 9.30899 10.6502L9.75587 10.0409C9.79805 9.98304 9.78555 9.90492 9.7293 9.86585L7.50118 8.25492V4.38773C7.50118 4.31898 7.44493 4.26273 7.37618 4.26273ZM10.8106 5.43773L13.2606 6.03617C13.3387 6.05492 13.4152 5.99554 13.4152 5.91585L13.4277 3.39242C13.4277 3.28773 13.3074 3.22835 13.2262 3.29398L10.7637 5.21742C10.7451 5.23181 10.7309 5.25117 10.7228 5.27326C10.7147 5.29536 10.713 5.31928 10.7179 5.3423C10.7228 5.36531 10.7341 5.38648 10.7505 5.40336C10.7669 5.42024 10.7877 5.43216 10.8106 5.43773ZM13.4309 10.1424L12.5449 9.83773C12.514 9.82714 12.4802 9.82906 12.4507 9.84308C12.4213 9.85709 12.3984 9.88209 12.3871 9.91273C12.3574 9.99242 12.3262 10.0705 12.2934 10.1487C12.0152 10.8065 11.6168 11.3987 11.1074 11.9065C10.6037 12.4118 10.0067 12.8145 9.34962 13.0924C8.66888 13.3802 7.93713 13.528 7.19805 13.5268C6.45118 13.5268 5.72774 13.3815 5.04649 13.0924C4.38936 12.8145 3.7924 12.4118 3.28868 11.9065C2.78086 11.3987 2.38243 10.8065 2.10274 10.1487C1.81652 9.46755 1.66987 8.73592 1.67149 7.9971C1.67149 7.25023 1.8168 6.52523 2.10586 5.84398C2.38399 5.18617 2.78243 4.59398 3.2918 4.08617C3.79552 3.58088 4.39249 3.17813 5.04962 2.90023C5.72774 2.61117 6.45274 2.46585 7.19962 2.46585C7.94649 2.46585 8.66993 2.61117 9.35118 2.90023C10.0083 3.17813 10.6053 3.58088 11.109 4.08617C11.2684 4.2471 11.4184 4.41429 11.5559 4.59085L12.4902 3.8596C11.2606 2.28773 9.34649 1.27679 7.19649 1.27835C3.45274 1.27992 0.44649 4.32054 0.48399 8.06585C0.52149 11.7455 3.51368 14.7159 7.19962 14.7159C10.0981 14.7159 12.5668 12.8784 13.5074 10.3049C13.5309 10.2393 13.4965 10.1659 13.4309 10.1424Z",
    fill: "black",
    fillOpacity: 0.45
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2921_195949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.998047)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2921_195949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.998047)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.4b3ac029.svg";
export { ForwardRef as ReactComponent };